import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bc219366"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }

import MainLogo from "@/components/MainLogo.vue";
import AuthEmail from "@/components/auth/AuthEmail.vue";
import AuthCode from "@/components/auth/AuthCode.vue";
import { ref, Ref } from "vue";
import PopupTemplate from "@/components/popups/PopupTemplate.vue";
import { useUserStore } from "@/stores/user";


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupAuth',
  setup(__props) {

const userStore = useUserStore();

const codeSent: Ref<boolean> = ref(false);

const onBack = (): void => {
  userStore.email = "";
  codeSent.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupTemplate, { width: 400 }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(MainLogo, { class: "login__logo" }),
        (codeSent.value)
          ? (_openBlock(), _createBlock(AuthCode, {
              key: 0,
              onBack: onBack
            }))
          : (_openBlock(), _createBlock(AuthEmail, {
              key: 1,
              onCodeSent: _cache[0] || (_cache[0] = ($event: any) => (codeSent.value = true))
            }))
      ])
    ]),
    _: 1
  }))
}
}

})